// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2ce1C","label":"Radio_label__1UCz-","checkMark":"Radio_checkMark__1DqPK","disabled":"Radio_disabled__2Qsuo"};